/* global math ElementEleda Question_Open */
import { styleSettings } from "../../../../../src/config/settings-features.mjs";

//Utils import
import { isNumeric } from "../numeric/Utils-Numeric.mjs";

/********************** STYLES COLOR SIZE ALIGNMENT *********************************/
const DEFAULT_STYLE = {
  color: "",
  size: "",
  alignment: "",
};

// Add style property to String prototype
Object.defineProperty(String.prototype, "style", {
  writable: true,
  value: { ...DEFAULT_STYLE },
});

// Add style property to Number prototype
Object.defineProperty(Number.prototype, "style", {
  writable: true,
  value: { ...DEFAULT_STYLE },
});

/**
 * Set styles to an object while preserving existing styles
 * @param {*} object - Target object
 * @param {Object} newStyle - Style properties to apply
 * @returns {*} - Styled object
 */
export function setStyleToObject(object, newStyle) {
  let objectWithStyle = object;

  // Convert primitives to objects if needed
  if (typeof object === "string") {
    objectWithStyle = new String(object);
    // Initialize style if it doesn't exist
    if (!objectWithStyle.style) {
      objectWithStyle.style = { ...DEFAULT_STYLE };
    }
  } else if (
    isNumeric(object) &&
    !(object instanceof Number) &&
    !(object instanceof Element_Fraction) &&
    !["Fraction", "BigNumber", "boolean", "Complex"].includes(
      math.typeOf(object)
    )
  ) {
    objectWithStyle = new Number(object);
    // Initialize style if it doesn't exist
    if (!objectWithStyle.style) {
      objectWithStyle.style = { ...DEFAULT_STYLE };
    }
  }

  // Apply styles based on object type
  if (
    objectWithStyle instanceof String ||
    objectWithStyle instanceof Number ||
    objectWithStyle instanceof math.BigNumber
  ) {
    // Merge existing styles with new styles
    objectWithStyle.style = {
      ...DEFAULT_STYLE,
      ...objectWithStyle.style,
      ...newStyle,
    };
  } else if (
    objectWithStyle instanceof ElementEleda ||
    objectWithStyle instanceof Question_Open
  ) {
    objectWithStyle.setStyle(newStyle);
  } else if (objectWithStyle instanceof Object) {
    // Initialize style if it doesn't exist
    if (!objectWithStyle.style) {
      objectWithStyle.style = { ...DEFAULT_STYLE };
    }
    // Merge existing styles with new styles
    objectWithStyle.style = {
      ...DEFAULT_STYLE,
      ...objectWithStyle.style,
      ...newStyle,
    };
  }
  return objectWithStyle;
}
/*
Object.defineProperty(math.BigNumber.prototype, "style", {
  writable: true,
  value: { color: "", size: "", alignment: "" },
});
*/

export function setRandomColorToObject(object) {
  var objectWithColor = object;
  console.log("styleSettings", styleSettings.color);
  //Old fashion
  /* var numColor = Math.floor(Math.random() * Math.pow(2, 24));
  var strColor = "#" + ("00000" + numColor.toString(16)).substr(-6);
  setStyleToObject(objectWithColor, { color: strColor });*/
  var randomColor = getRandomColor();
  return setStyleToObject(objectWithColor, {
    color: randomColor,
  });
}
/**
 * Select only the random color among styleSettings list
 * @returns color
 */
export function getRandomColor() {
  var keys = Object.keys(styleSettings.color);
  keys = keys.filter((key) => key != "light" && key != "white");
  return styleSettings.color[keys[Math.floor(Math.random() * keys.length)]];
}
/**
 * Returns if a str is a hexa html color (3 or 6 numbers #0de or #dd1122 )
 * Ref : https://stackoverflow.com/questions/8027423/how-to-check-if-a-string-is-a-valid-hex-color-representation
 * @param {*} hexa
 * @returns
 */
export function isValidHexColor(str) {
  return /^#([0-9A-F]{3}){1,2}$/i.test(str);
}

/**
 * Apply the inner JSON style to node.
 * @param {*} style
 * @param {*} node
 */
export function applyColorAndSizeStyleToNode(node, style) {
  if (style && node) {
    if (style.color) {
      if (node.style) {
        node.style.color = style.color;
      } else {
        node.style = { color: style.color };
      }
    }
    //Because xxx-large doesn't work on many browsers we use bulma style instead
    if (style.size && node.classList) {
      node.classList.add(style.size);
    }
  }
}

/**
 * Apply the inner JSON style alignment to DIV node type.
 * @param {*} style
 * @param {*} node
 */
export function applyAlignmentStyleToFlex(node, style) {
  if (style && node) {
    if (style.alignment) {
      node.classList.remove(
        "is-justify-content-right",
        "is-justify-content-left",
        "is-justify-content-center"
      );
      switch (style.alignment) {
        case "right":
          node.classList.add("is-justify-content-right");
          break;
        case "left":
          node.classList.add("is-justify-content-left");
          break;
        case "center":
          node.classList.add("is-justify-content-center");
          break;
        default:
          node.classList.add("is-justify-content-left");
      }
    }
  }
}

export function applyAlignmentStyleToDiv(node, style) {
  if (style && node) {
    if (style.alignment) {
      //node.setAttribute("align", style.alignment);
      node.classList.remove(
        "has-text-right",
        "has-text-left",
        "has-text-centered"
      );
      console.log("applyAlignmentStyleToDiv", style.alignment);
      switch (style.alignment) {
        case "right":
          node.classList.add("has-text-right");
          break;
        case "left":
          node.classList.add("has-text-left");
          break;
        case "center":
          node.classList.add("has-text-centered");
          break;
        default:
          node.classList.add("has-text-left");
      }
    }
  }
}

export function applyAlignmentStyleToText(node, style) {
  if (style && node) {
    if (style.alignment) {
      node.setAttribute("align", style.alignment);
      node.classList.remove(
        "has-text-right",
        "has-text-left",
        "has-text-centered"
      );
      switch (style.alignment) {
        case "right":
          node.classList.add("has-text-right");
          break;
        case "left":
          node.classList.add("has-text-left");
          break;
        case "center":
          node.classList.add("has-text-centered");
          break;
        default:
          node.classList.add("has-text-left");
      }
    }
  }
}

////////////OLD FUNCTIONS
export const DEBUG = true;
const debugInConsole = true;

// URLs
/**
 * Extracts a parameter from the URL.
 * If the parameter is absent default_value is returned.
 * @param {string} name The name of the parameter.
 * @param {string} defaultValue Value to return if parameter not found.
 * @return {string} The parameter value or the default value if not found.
 */
export function getStringParamFromUrl(name, defaultValue) {
  var val = location.search.match(new RegExp("[?&]" + name + "=([^&]+)"));
  return val ? decodeURIComponent(val[1].replace(/\+/g, "%20")) : defaultValue;
}

export function appendDEBUG(text, balise = "p") {
  if (DEBUG) {
    if (debugInConsole) {
      //console.log(text);
    } else {
      var node = document.createElement(balise);
      node.setAttribute("class", "debug");

      var textnode = document.createTextNode(text);
      node.appendChild(textnode);
      document.getElementById("debugEleda").appendChild(node);
    }
  }
}

export function convertIntoDebug(object) {
  // console.log("convertIntoDebug:", object);
  var text;
  if (!object) {
    console.log("object is null");
    text = "not yet defined or null";
  } else {
    //Is the object has a toString()
    try {
      text = object.toString();
    } catch (e) {
      console.log(
        "toString method exists but error, try JSON.stringify instead"
      );
      try {
        text = JSON.stringify(object);
      } catch (e) {
        console.log(
          "toString method exists but error, try JSON.stringify instead"
        );
        text = "not able to display object as string";
      }
    }
  }
  return text;
}
